module.exports = __webpack_public_path__ + "img/infosecurity-24.4d6c23d9.svg";